module.exports = __webpack_public_path__ + "static/media/Ticketing-Table-for-2-B.e8672bc0.svg";